import {
  buildTsplLabelDocument,
  type LabelPrintFormat,
  type LabelPrintRotation,
  type ProductLabelData,
} from "@itaas/label-print";

export { buildTsplLabelDocument };

const DEFAULT_BAUD = 9600;

export function isWebSerialLabelPrintAvailable(): boolean {
  return typeof navigator !== "undefined" && "serial" in navigator;
}

export async function printLabelViaWebSerial(
  label: ProductLabelData,
  format: LabelPrintFormat,
  rotation: LabelPrintRotation = 0,
  baudRate = DEFAULT_BAUD,
): Promise<void> {
  if (!isWebSerialLabelPrintAvailable()) {
    throw new Error(
      "Impression USB directe indisponible — utilisez Chrome/Edge récent ou ITaaS Print Bridge.",
    );
  }

  const port = await navigator.serial!.requestPort();
  await port.open({ baudRate });

  try {
    const payload = buildTsplLabelDocument(label, format, rotation);
    const writer = port.writable?.getWriter();
    if (!writer) throw new Error("Port série non accessible en écriture");
    await writer.write(new TextEncoder().encode(payload));
    writer.releaseLock();
  } finally {
    await port.close();
  }
}
